module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/c2-d904711680da694af8c6ff4cfde3f6a6.png";